module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#speaker",
      toString: function () {
        return this.url;
      }
    }